<template>
  <div>
    <!-- <template v-for="item in faqEntries">
      <div :key="item.id">
        <h3>
          {{ item.Question }}
        </h3>
        <span v-html="item.Answer" />
      </div>
    </template> -->
    <v-expansion-panels>
      <v-expansion-panel v-for="item in faqEntries" :key="item.id">
        <v-expansion-panel-header>
          <b class="my-2">
            {{ item.Question }}
          </b>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <span v-html="modifyImageUrl(item.Answer)" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { HTTP } from '@/main/httpClient.js';

export default {
  name: 'Faq',
  components: {},
  props: {
    gAgs: {
      type: String,
      required: true
    },
    existingHouseConnection: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: () => ({
    faqEntries: undefined
  }),
  computed: {},
  mounted() {
    this.getFaq();
  },
  methods: {
    getFaq(faqName) {
      HTTP.get('/past/documentation/spot-faq-online-kbls').then((resp) => {
        if (resp && resp.data && resp.data.length) {
          this.faqEntries = resp.data;
          console.log(resp.data);
        }
      });
    },
    modifyImageUrl(string) {
      if (string) {
        return string.replace('/uploads', 'https://cms.goetel.de/uploads');
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
